module.exports = __webpack_public_path__ + "static/media/tutorial-photos-step1.580f7b1f.png";